// import React, { useState } from "react";
// import { Container, Row, Col, Card, Button, Table, Form, Modal } from "react-bootstrap";

const Taxes = () => {

}

export default Taxes;